import { useMemo } from 'react';
import { UseMutationExecute } from 'urql';

import {
  GetUserSettingsQuery,
  useCreateUserSettingsMutation,
  useGetUserSettingsQuery,
  useUpdateUserSettingsMutation,
} from '@phoenix/team-m/dashboard/frontend/domain/generated/graphql';

export const useUserSettings = (settingsName: string): [GetUserSettingsQuery | undefined, UseMutationExecute] => {
  const context = useMemo(
    () => ({
      url: process.env.NEXT_PUBLIC_UI_USER_SETTINGS_GRAPHQL_ENDPOINT,
    }),
    []
  );
  const [{ data }] = useGetUserSettingsQuery({
    variables: { name: settingsName },
    context,
  });

  const [_u, update] = useUpdateUserSettingsMutation();
  const [_c, create] = useCreateUserSettingsMutation();

  const mutateService = (setting) => (data?.userSetting?.setting ? update : create)({ name: settingsName, setting }, context);

  return [data, mutateService];
};
